module.exports = __webpack_public_path__ + "static/media/ow2ll16.1652cf3e.png";